import {
  Actions,
  PrepAndSendAction,
  CoverPage,
} from 'hellospa/page/prep-and-send/data/types';

export const setCoverPage = (
  coverpage: Partial<CoverPage>,
): PrepAndSendAction => ({
  type: Actions.UpdateCoverPage,
  payload: coverpage,
});
